import React from 'react';
import { connect } from 'react-redux';
import Button from "../UI/Button/Button";
import styles from "./StoreNotAvailable.css";

const StoreNotAvailableC = ({ onClick, isError = false, translations, availabilityTranslations, phone }) => {
    let component = null;
    if (isError) {
        component = 
            <React.Fragment>
                <p className={styles.StoreNotAvailableTitle}>{translations.label_error_server}</p>
                <p className={styles.StoreNotAvailableText}>{translations.label_message_sorry_no_time}</p>
            </React.Fragment>     
    } else if (availabilityTranslations) {
        component = <React.Fragment>
            <p className={styles.StoreNotAvailableTitle}>{translations.label_title_sorry_no_time}</p>
            {availabilityTranslations.primaryTitle && <p className={styles.AvailabilityTitle}>{availabilityTranslations.primaryTitle}</p>}
            <p className={styles.AvailabilityMessage}>{availabilityTranslations.primaryMessageNotAvailable}</p>
            <div className={styles.StoreNotAvailableButtonContainer}>
                <Button btnLabel={<a className={styles.PhoneLink} href={`tel:${phone}`}>{phone}</a>} />
            </div>
            <p className={styles.AvailabilityTitle}>{translations.label_or}</p>
        </React.Fragment>
    } else {
        component = 
            <React.Fragment>
                <p className={styles.StoreNotAvailableTitle}>{translations.label_title_sorry_no_time}</p>
                <p className={styles.StoreNotAvailableText}>{translations.label_message_sorry_no_time}</p>
            </React.Fragment>
    }
    return (
        <div className={styles.StoreNotAvailable}>
            {component}
            <div className={styles.StoreNotAvailableButtonContainer}>
                <Button
                    btnLabel={translations.label_looking_for_other_store}
                    clicked={onClick}
                />
            </div>
        </div>
    )
}

export const StoreNotAvailable = connect(state => {
    return {
        translations: state.settingsReducer.translations,
        availabilityTranslations: state.storeReducer.stores[state.storeReducer.storeIdSelected].availabilityTranslations,
        phone: state.storeReducer.stores[state.storeReducer.storeIdSelected].phone,
    }
})(StoreNotAvailableC);


// WEBPACK FOOTER //
// ./src/components/TimePicker/StoreNotAvailable.js